"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseElementViewModel = void 0;
class BaseElementViewModel {
    constructor(baseElement, processModel) {
        var _a, _b;
        this.id = baseElement.id;
        this.documentation = baseElement.documentation;
        this.customProperties = {};
        this.processModelId = processModel.processModelId;
        this.processModelName = processModel.processModelName;
        if ((_a = baseElement.extensionElements) === null || _a === void 0 ? void 0 : _a.camundaExtensionProperties) {
            for (const camundaExtensionProperty of (_b = baseElement.extensionElements) === null || _b === void 0 ? void 0 : _b.camundaExtensionProperties) {
                this.customProperties[camundaExtensionProperty.name] = camundaExtensionProperty.value;
            }
        }
    }
}
exports.BaseElementViewModel = BaseElementViewModel;
//# sourceMappingURL=BaseElementViewModel.js.map